import { render, staticRenderFns } from "./HKLInputPoints.vue?vue&type=template&id=2869240d&scoped=true&"
import script from "./HKLInputPoints.vue?vue&type=script&lang=js&"
export * from "./HKLInputPoints.vue?vue&type=script&lang=js&"
import style0 from "./HKLInputPoints.vue?vue&type=style&index=0&id=2869240d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2869240d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2869240d')) {
      api.createRecord('2869240d', component.options)
    } else {
      api.reload('2869240d', component.options)
    }
    module.hot.accept("./HKLInputPoints.vue?vue&type=template&id=2869240d&scoped=true&", function () {
      api.rerender('2869240d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/components/HKLInputPoints.vue"
export default component.exports